import React, { useState } from 'react';

import Grid from '@mui/material/Grid2';

import { 
  Character,
  DandDFeatureSource
} from "@dndModels";
import { PALETTE } from "@dndModels/Constants";
import { ColorsType } from '../../../../../DandDPalette';

import DandDCharacterUtilities from "@dndUtilities/char_utilities";

import ModalOrDrawer from "@components/display/ModalOrDrawer";
import ColorsButton from "@components/input/buttons/ColorsButton";
import ColorsBox from "@components/input/buttons/ColorsBox";
import CheckBox from "@components/input/CheckBox";

interface Props {
  character: Character;
}

const char_util = DandDCharacterUtilities.getInstance();

export default function CharacterColorsButton({
  character,
}: Props) {
  const [open, setOpen] = useState(false);
  const [ping, setPing] = useState(false);

  const renderExtras = () => {
    const wide_mode = window.innerWidth > 800;
    // console.log(character.classes);
    return (
      <ModalOrDrawer 
        open={ open } 
        width={ wide_mode ? 800 : undefined }
        onClose={() => {
          setOpen(false);
        }}>
        { open &&
          <Grid container spacing={0} direction="row" style={{ maxHeight: window.innerHeight - 34 }}>
            <Grid
              className="header centered"
              size={{
                xs: 12
              }}>Character Colors</Grid>
            <Grid
              size={{
                xs: 12
              }}>{ renderColorsRow("Default") }</Grid>
            <Grid
              size={{
                xs: 12
              }}>{ renderColorsRow("Attacks") }</Grid>
            { character.race.source && <Grid
              size={{
                xs: 12
              }}>{ renderColorsRow(character.race.source_id) }</Grid> }
            { character.race.char_subrace && character.race.char_subrace.source && <Grid
              size={{
                xs: 12
              }}>{ renderColorsRow(character.race.char_subrace.source_id) }</Grid> }
            { character.background.source && <Grid
              size={{
                xs: 12
              }}>{ renderColorsRow(character.background.source_id) }</Grid> }
            { character.classes.map(char_class => {
              return (
                <Grid
                  key={char_class.true_id}
                  size={{
                    xs: 12
                  }}>
                  { renderColorsRow(char_class.source_id) }
                </Grid>
              );
            })}
          </Grid>
        }
      </ModalOrDrawer>
    );
  }

  const renderColorsRow = (for_id: string) => {
    if (for_id === "Default") {
      return (
        <Grid container spacing={0} direction="row">
          <Grid
            className="header"
            size={{
              xs: 3
            }}>Default</Grid>
          <Grid
            size={{
              xs: 9
            }}>
            { character.colors_for.Default && 
              <ColorsBox
                colors={character.colors_for.Default}
                onChange={(changed: ColorsType) => {
                  character.colors_for.Default = changed;
                  character.changed();
                  character.subscription_holder.recalculated();
                  setPing(!ping);
                }}
              />
            }
          </Grid>
          <Grid
            size={{
              xs: 12
            }}>
            <CheckBox
              name="Use System Default"
              value={ character.colors_for.Default === undefined }
              onChange={(changed: boolean) => {
                if (changed) {
                  delete character.colors_for.Default;
                } else {
                  character.colors_for.Default = {
                    backgroundColor: PALETTE.secondary.main,
                    color: PALETTE.secondary.light
                  };
                }
                character.changed();
                character.subscription_holder.recalculated();
                setPing(!ping);
              }}
            />
          </Grid>
        </Grid>
      );
    } else if (for_id === "Attacks") {
      return (
        <Grid container spacing={0} direction="row">
          <Grid
            className="header"
            size={{
              xs: 3
            }}>Attacks</Grid>
          <Grid
            size={{
              xs: 9
            }}>
            { character.colors_for.Attacks && 
              <ColorsBox
                colors={character.colors_for.Attacks}
                onChange={(changed: ColorsType) => {
                  character.colors_for.Attacks = changed;
                  character.changed();
                  character.subscription_holder.recalculated();
                  setPing(!ping);
                }}
              />
            }
          </Grid>
          <Grid
            size={{
              xs: 12
            }}>
            <CheckBox
              name="Use System Default"
              value={ character.colors_for.Attacks === undefined }
              onChange={(changed: boolean) => {
                if (changed) {
                  delete character.colors_for.Attacks;
                } else {
                  character.colors_for.Attacks = {
                    backgroundColor: PALETTE.attack.main,
                    color: PALETTE.attack.light
                  };
                }
                character.changed();
                character.subscription_holder.recalculated();
                setPing(!ping);
              }}
            />
          </Grid>
        </Grid>
      );
    } else {
      const cfs = character.all_char_feature_sources.find(o => o.source_id === for_id);
      if (cfs) {
        // console.log(character.colors_for[for_id]);
        return (
          <Grid container spacing={0} direction="row">
            <Grid
              className="header"
              size={{
                xs: 3
              }}>{ char_util.getUseName(cfs) }</Grid>
            <Grid
              size={{
                xs: 9
              }}>
              { character.colors_for[for_id] && 
                <ColorsBox
                  colors={character.colors_for[for_id]}
                  onChange={(changed: ColorsType) => {
                    character.colors_for[for_id] = changed;
                    character.changed();
                    character.subscription_holder.recalculated();
                    setPing(!ping);
                  }}
                />
              }
            </Grid>
            <Grid
              size={{
                xs: 12
              }}>
              <CheckBox
                name="Use System Default"
                value={ character.colors_for[for_id] === undefined }
                onChange={(changed: boolean) => {
                  if (changed) {
                    delete character.colors_for[for_id];
                  } else {
                    let backgroundColor = PALETTE.secondary.main;
                    let color = PALETTE.secondary.light;
                    if (cfs.source instanceof DandDFeatureSource) {
                      if (cfs.source.colors.backgroundColor !== "") {
                        backgroundColor = cfs.source.colors.backgroundColor;
                      }
                      if (cfs.source.colors.color && cfs.source.colors.color !== "Default") {
                        color = cfs.source.colors.color;
                      }
                    } 
                    character.colors_for[for_id] = {
                      backgroundColor,
                      color
                    };
                  }
                  character.changed();
                  character.subscription_holder.recalculated();
                  setPing(!ping);
                }}
              />
            </Grid>
          </Grid>
        );
      }
    }
    return null;
  }

  return (
    <>
      <ColorsButton
        onClick={() => {
          setOpen(true);
        }}
      />
      { renderExtras() }
    </>
  ); 
}
